import styled, { css } from 'styled-components';
import selectBackground from '../../../asset/img/common/arrow_down.svg';

export const SelectBoxStyled = styled.div`
  /* Select box */
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  gap: ${props => (props.size == 'small' ? '4px' : '8px')};
  select {
    -webkit-appearance: none; /* for chrome */
    -moz-appearance: none; /*for firefox*/
    appearance: none;
  }
  select::-ms-expand {
    display: none; /*for IE10,11*/
  }
  select {
    background: url(${selectBackground}) no-repeat 97% 50%/24px auto;
  }
  .selectLabel {
    display: inline-block;
    color: var(--GrayScale-700);
    font-weight: 400;
  }
  .selectDiv {
    background: #ffffff;
  }
  .select {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-sizing: border-box;
    cursor: pointer;
    padding-right: 22px;
  }
  .select:focus {
    border-color: var(--Primary-500);
    outline: none;
  }
  .select:disabled {
    background-color: #f5f5f5;
    border: 1px solid #cccccc;
  }

  option {
    background-color: #ffffff;
  }
  ${props => {
    let styles = '';
    if (props.size == 'large') {
      styles += `
        padding: 12px;
        padding-right: 22px;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        option {
          padding: 12px;
          font-family: Pretendard;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;
        }
      `;
    } else if (props.size == 'medium') {
      styles += `
        padding: 8px;
        padding-right: 22px;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        option {
          padding: 8px;
          font-family: Pretendard;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
        }
      `;
    } else if (props.size == 'small') {
      styles += `
        padding: 4px 8px;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        option {
          padding: 4px 8px;
          font-family: Pretendard;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px;
        }
      `;
    }

    return css`
      .select {
        ${styles}
      }
    `;
  }}
`;
